import isInteger from 'lodash/isInteger';
import isString from 'lodash/isString';
import { object } from 'prop-types';
import { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { history } from 'react-router-prop-types';

import Error404Page from 'shared/containers/Error404Page';
import { user } from 'shared/redux/selectors';

import BetContainer from './BetContainer';
import Dialogs from './Dialogs';

const mapStateToProps = state => ({
  isLoggedIn: user.isLoggedIn(state),
});

export default connect(mapStateToProps)(
  class BetRouteContainer extends Component {
    static propTypes = {
      jokerController: object.isRequired,
      history: history.isRequired,
    };

    state = {
      error: undefined,
    };

    componentWillUnmount() {
      this.props.jokerController.removeAtgDialogs();
    }

    renderBet({ betId, shareCode }) {
      const { jokerController } = this.props;
      return (
        <Fragment>
          <Dialogs jokerController={jokerController} />
          <BetContainer betId={betId} shareCode={shareCode} {...this.props} />
        </Fragment>
      );
    }

    render() {
      const {
        match: { params, path },
      } = this.props;
      const { error } = this.state;

      if (error && error.status === 404) {
        return <Route component={Error404Page} />;
      }

      // Loaded on a bet route
      if (path === '/trav/:betId' && !Number.isNaN(params.betId)) {
        const betId = Number.parseFloat(params.betId);
        if (isInteger(betId)) {
          return this.renderBet({ betId });
        }
      }

      // Loaded on a shared bet route
      if (path === '/trav/dela/:shareCode') {
        const shareCode = params.shareCode;
        if (isString(shareCode)) {
          return this.renderBet({ shareCode });
        }
      }

      // Invalid path, return 404 page
      return <Route component={Error404Page} />;
    }
  },
);
